import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

import useFullServiceInvoice from './hooks/useFullServiceInvoiceData';
import FullServiceInvoiceTable from './components/FullServiceInvoiceTable';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { usePermissions } from '../../hooks/usePermissions';

import { useSelector } from 'react-redux';
import { useGetUserParamsQuery } from '../../api';
import { selectUserParams } from '../../store/slices/userParamsSlice';
import FullServiceInvoiceFilter from './components/FullServiceInvoiceFilter';


const FullServiceInvoicePage = () => {
    const { th } = useLanguage();
    const toast = useRef(null);
    const navigate = useNavigate();

    const { data: response } = useGetUserParamsQuery();
    const userParamsFromStore = useSelector(selectUserParams);
    const userParams = userParamsFromStore || response || {};
    const isCanUseFullService = userParams.isKmobilityUser;


    const { invoices, totalCount, loading, lazyParams, onPage, onSort, handleDelete, refetch, activeFilters, handleFilterChange, initFilters } = useFullServiceInvoice();

    const { hasWarrantyTeamRole, hasAdminRole,hasWarrantyManagerRole } = usePermissions();

    // Yetki kontrolü: Warranty ekibi veya Kmobility kullanıcıları
    const canCreate = hasAdminRole() || hasWarrantyTeamRole() || hasWarrantyManagerRole();

    const handleCreateClick = () => {
        navigate('/full-service/create-edit');
    };

    const handleEdit = (invoice) => {
        if (!invoice?.id) return;
        navigate(`/full-service/create-edit/${invoice.id}`);
    };

    const handleDeleteClick = (id) => {
        confirmDialog({
            message: th('fullServiceInvoice.confirmDialog.delete.message'),
            header: th('fullServiceInvoice.confirmDialog.delete.header'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: th('fullServiceInvoice.confirmDialog.delete.acceptLabel'),
            rejectLabel: th('fullServiceInvoice.confirmDialog.delete.rejectLabel'),
            accept: async () => {
                const result = await handleDelete(id);
                if (result?.isSuccessful) {
                    toast.current?.show({
                        severity: 'success',
                        summary: th('fullServiceInvoice.toastMessages.deletedSummary'),
                        detail: th('fullServiceInvoice.toastMessages.deleted'),
                        life: 3000
                    });
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: th('fullServiceInvoice.toastMessages.errorSummary'),
                        detail: th('fullServiceInvoice.toastMessages.deleteFailed'),
                        life: 3000
                    });
                }
            },
            rejectClassName: 'p-button-outlined'
        });
    };

    return (
        <div className="card">
            <Toast ref={toast} />
            <ConfirmDialog />

            <div className="flex justify-content-between mb-4">
                <h1 className="m-0">{th("menu.tenderSpecifications")}</h1>
                {canCreate && <Button label={th('fullServiceInvoice.page.newButton')} icon="pi pi-plus" onClick={handleCreateClick} />}
            </div>

            <div className="mb-2">
                <FullServiceInvoiceFilter
                    onApplyFilters={(f) => {
                        handleFilterChange(f);
                    }}
                    onResetFilters={initFilters}
                />
            </div>

            <FullServiceInvoiceTable
                invoices={invoices}
                hidePrice={isCanUseFullService}
                isKMobility={isCanUseFullService}
                loading={loading}
                totalCount={totalCount}
                lazyParams={lazyParams}
                onPage={onPage}
                onSort={onSort}
                onEdit={handleEdit}
                onDelete={handleDeleteClick}
                handleEdit={handleEdit}
            />
        </div>
    );
};

export default FullServiceInvoicePage;
